export default {
  name: 'evaluate-answer-edit',
  created () {
    this.search()
  },
  data () {
    return {
      isSearchEnd: false,
      isReSend: false,
      stepUpUser: null,
      title: '',
      evaluateNormalAnswers: [],
      selectNormalAnswers: [
        {value: null, content: '回答前'},
        {value: 1, content: 'はい'},
        {value: 2, content: 'いいえ'}
      ],
      evaluatePersonnelAnswers: [],
      selectPersonnelAnswers: [
        {value: null},
        {value: 1},
        {value: 2},
        {value: 3},
        {value: 4}
      ],
      evaluateBusinessAnswers: [],
      selectBusinessAnswers: [
        {value: null},
        {value: 1},
        {value: 2},
        {value: 3},
        {value: 4}
      ],
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    isAllAnswer () {
      for (let i = 0; i < this.evaluateNormalAnswers.length; i++) {
        if (!this.evaluateNormalAnswers[i].answer_content) {
          return false
        }
      }
      for (let i = 0; i < this.evaluatePersonnelAnswers.length; i++) {
        if (!this.evaluatePersonnelAnswers[i].answer_content) {
          return false
        }
      }
      for (let i = 0; i < this.evaluateBusinessAnswers.length; i++) {
        if (!this.evaluateBusinessAnswers[i].answer_content) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    async search () {
      let data = {
        id: this.$route.params.id
      }
      let res = await this.$store.dispatch('EVALUATE_ANSWER_ANSWER_DETAIL_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.title = res.evaluate_question_title
      this.stepUpUser = res.step_up_user
      this.evaluateNormalAnswers = res.evaluate_normal_answer
      this.evaluatePersonnelAnswers = res.evaluate_personal_answer.data.map(answer => {
        return {
          id: parseInt(answer.id),
          answer_content: answer.attributes['answer-content'],
          display_order: answer.attributes['display-order'],
          evaluate_answer_id: answer.attributes['evaluate-answer-id'],
          question_content: answer.attributes['question-content'],
          word: answer.attributes.word
        }
      })
      this.evaluateBusinessAnswers = res.evaluate_business_answer.data.map(answer => {
        return {
          id: parseInt(answer.id),
          answer_content: answer.attributes['answer-content'],
          display_order: answer.attributes['display-order'],
          evaluate_answer_id: answer.attributes['evaluate-answer-id'],
          question_content: answer.attributes['question-content'],
          word: answer.attributes.word
        }
      })
      // TODO(sakaguchi)
      // if (this.stepUpUser.is_all_answered) {
      //   this.isReSend = true
      //   this.selectAnswers.shift()
      // } else {
      //   this.isReSend = false
      // }
      this.isSearchEnd = true
    },
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goEvaluateAnswerList: function () {
      this.$router.push({ path: '/evaluate_answer/' + this.$route.params.id + '/answered_list' })
    },
    async answerSend () {
      const evaluateAnswerId = parseInt(this.$route.params.id)
      const data = {
        evaluate_answer: {id: evaluateAnswerId},
        evaluate_normal_answer: this.evaluateNormalAnswers,
        evaluate_personal_answer: this.evaluatePersonnelAnswers,
        evaluate_business_answer: this.evaluateBusinessAnswers
      }
      await Promise.all([
        this.$store.dispatch('EVALUATE_ANSWER_ANSWER_UPDATE', {id: evaluateAnswerId, data: data}),
        this.$store.dispatch('EVALUATE_ANSWER_ALL_ANSWER_UPDATE', {id: evaluateAnswerId})
      ])
      .catch(err => {
        console.log(err)
        return
      })
      // モーダル表示
      this.stepupSendModal('send')
    },
    async tempSave () {
      const evaluateAnswerId = parseInt(this.$route.params.id)
      let data = {
        evaluate_answer: {id: evaluateAnswerId},
        evaluate_normal_answer: this.evaluateNormalAnswers,
        evaluate_personal_answer: this.evaluatePersonnelAnswers,
        evaluate_business_answer: this.evaluateBusinessAnswers
      }
      await this.$store.dispatch('EVALUATE_ANSWER_ANSWER_UPDATE', {id: evaluateAnswerId, data: data})
      .catch(err => {
        console.log(err)
        return
      })
      // モーダル表示
      this.stepupSendModal('temp')
    },
    selectedStyle: function (index, radioVal) {
      if (this.isReSend) {
        if (!radioVal && !this.evaluateNormalAnswers[index].answer_content) {
          return 'stepupAnswerRadioBg'
        }
        if (this.evaluateNormalAnswers[index].answer_content === (radioVal + 1)) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      } else {
        if (!radioVal && !this.evaluateNormalAnswers[index].answer_content) {
          return 'stepupAnswerRadioBg'
        }
        if (this.evaluateNormalAnswers[index].answer_content === radioVal) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      }
    },
    selectedStylePersonnel: function (index, radioVal) {
      if (this.isReSend) {
        if (!radioVal && !this.evaluatePersonnelAnswers[index].answer_content) {
          return 'stepupAnswerRadioBg'
        }
        if (this.evaluatePersonnelAnswers[index].answer_content === (radioVal + 1)) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      } else {
        if (!radioVal && !this.evaluatePersonnelAnswers[index].answer_content) {
          return 'stepupAnswerRadioBg'
        }
        if (this.evaluatePersonnelAnswers[index].answer_content === radioVal) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      }
    },
    selectedStyleBusiness: function (index, radioVal) {
      if (this.isReSend) {
        if (!radioVal && !this.evaluateBusinessAnswers[index].answer_content) {
          return 'stepupAnswerRadioBg'
        }
        if (this.evaluateBusinessAnswers[index].answer_content === (radioVal + 1)) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      } else {
        if (!radioVal && !this.evaluateBusinessAnswers[index].answer_content) {
          return 'stepupAnswerRadioBg'
        }
        if (this.evaluateBusinessAnswers[index].answer_content === radioVal) {
          return 'stepupAnswerRadioBg'
        }
        return ''
      }
    },

    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    isAnswered: function (content) {
      return content ? 'answered' : ''
    },
    stepupSendModal: function (mode) {
      let modal = ''
      if (mode === 'send') {
        modal = 'stepupSendModalButton'
      } else {
        modal = 'stepupTempSaveModalButton'
      }
      const button = document.getElementById(modal)
      button.click() // モーダル表示 イベント発火
    },
    newLineContent: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-answer-edit.js